import React from 'react';
import { ThemeProvider } from '@mui/material/styles';

import memoize from 'memoizee';
import theme from './theme';
import StoreContext from './store/context';
import RootStore from './store/store';
import {
  newsTransport,
  configTransport,
  fireSafetyTransport,
  videoTransport,
  videoCagegoryTransport,
  userTransport,
  collectedPointsTransportFactory,
  redeemedPointsTransportFactory,
  redeemProductsTransport,
} from './firebaseConnection/database';
import { registerForAuthChange } from './firebaseConnection/authentication';
import Router from './components/routes/Router';
import { getUser } from './http/requests';

const rootStore = new RootStore({
  roleStorePersistanceKey: 'RoleStore',
  userStoreTransport: userTransport,
  newsStoreTransport: newsTransport,
  fireSafetyStoreTransport: fireSafetyTransport,
  videoCagegoryTransport,
  videoTransport,
  configStoreTransport: configTransport,
  registerAuthChanged: registerForAuthChange,
  collectedPointsTransportFactory,
  redeemedPointsTransportFactory,
  redeemProductsTransport,
  getUserDataTransport: memoize(getUser, { promise: true }),
});

const App: React.FunctionComponent = () => (
  <div className="App">
    <StoreContext.Provider value={rootStore}>
      <ThemeProvider theme={theme}>
        <Router />
      </ThemeProvider>
    </StoreContext.Provider>
  </div>
);

export default App;
